<script>
import InputPrice from '../__components/InputPrice.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    InputPrice,
  },
  props: {
    value: {
      type: Number,
    },
  },
  mounted() {
    this.$emit('fixed-label', true);
  },
};
</script>
<template>
  <InputPrice
    class="f-flex__auto"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :min="module.min"
    :max="module.max"
    :scale="module.scale"
    :currency="module.currency"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
